module.exports = __webpack_public_path__ + "static/media/482-tss-visa-beaura-migration-agency.9a7cb745.jpg";